import { defineMessages } from 'react-intl'

export default defineMessages({
  errorTitle: {
    defaultMessage: 'Unerwarteter Anwendungsfehler',
  },
  databaseError: {
    defaultMessage:
      'Ein Problem mit der lokalen Datenbank wurde erkannt (Code: {code}).',
  },
  errorDetails: {
    defaultMessage: 'Fehlerdetails',
  },
  resetAppButton: {
    defaultMessage: 'Lokale Datenbank löschen und neu laden',
  },
  reloadApp: {
    defaultMessage: 'Neu laden',
  },
  offlineReady: {
    defaultMessage: 'Bereit, offline zu arbeiten',
  },
  newVersionAvailable: {
    defaultMessage:
      'Neue Softwareversion verfügbar, hier klicken zum aktualisieren',
  },
  reload: {
    defaultMessage: 'Neu laden',
  },
})
